<template>
    <div class="emc_card px-4 py-4 list-item-component">
        <div class="vx-row">
            <div class="vx-col w-full flex sm:items-center sm:flex-row flex-col">
                <div class="flex w-full justify-between items-center">
                    <div style="width: 100%" @click="go_online_registration(item)">
                        <div class="flex items-center mb-1">
                            <vs-chip class="mr-2" transparent  color="primary">
                                {{item.status.name}}
                            </vs-chip>
                            <vs-chip class="mr-2" transparent :color="statusColor(item)">
                                {{ item.profile.status.name }}
                            </vs-chip>
                            <div v-if="item.study_plan">
                                <vs-chip v-if="item.study_plan.preparation_level" class="mr-2" transparent  color="primary">
                                    {{ item.study_plan.preparation_level.name }}
                                </vs-chip>
                            </div>

                        </div>
                        <h5 class="todo-title">{{ item.profile.full_name }} ( {{ item.profile.student_id }} )</h5>
                        <div v-if="item.study_plan.group">
                            <span> {{ $t('groupp') }}: </span>
                            <span> {{ item.study_plan.group.name }} </span>
                        </div>
                        <div v-if="item.study_plan.students_and_teachers_load_type">
                            <span> {{ $t('students_load_types') }}: </span>
                            <span> {{ item.study_plan.students_and_teachers_load_type.name }} </span>
                        </div>
                        <div v-if="item.study_plan.course">
                            <span> {{ $t('course') }}: </span>
                            <span> {{ item.study_plan.course }} </span>
                        </div>
                        <div>
                            <span>
                                {{ $t('library_approval') }}:
                            </span>
                            <span v-if="item.has_library_debt">
                                {{ $t('No') }}
                            </span>
                            <span v-else>
                                {{ $t('Yes') }}
                            </span>
                        </div>
                        <div class="flex">
                            <div class="mr-2">
                                <span>Cr:</span>
                                <span>
                                    {{ item.current_credit }} /
                                    <span v-if="item.max_credit&&item.max_credit!==''">{{ item.max_credit }} </span>
                                    <span v-else>{{ item.rule_for_course_choosing?item.rule_for_course_choosing.max_credit:0 }} </span>
                                </span>
                            </div>
                            <div class="mr-2">
                                <span>AU:</span>
                                    <span>
                                    {{ current_credit_audit?item.current_credit_audit:0 }} /
                                    <span v-if="item.max_credit_audit&&item.max_credit_audit!==''">{{ item.max_credit_audit }}</span>
                                    <span v-else>{{ item.rule_for_course_choosing?item.rule_for_course_choosing.max_credit_audit:0 }}</span>
                                </span>
                            </div>
                        </div>
                    </div>


                    <vx-tooltip class="flex w-1/3 justify-end" :text="$t('online_registration_access_manual_setting')" position="left" delay=".3s">
                        <!--Изменение статусов пользователем фин отделом или учебным отделом-->
                        <div  v-if="user.role.is_fin_office||user.role.is_office">
                            <div>
                                {{ $t(item.online_registration_access) }}
                            </div>
                            <div >
                                <vs-button size="small" @click="setupPopup(item)" class="w-full">{{$t('change_access')}}</vs-button>
                                <vs-popup :title="$t('change_access')" :active.sync="fin_office_popup.status">
                                    <multiselect v-if="fin_office_popup.status"
                                            v-model="fin_office_popup.selection"
                                            :placeholder="fin_office_popup.selection?$t(fin_office_popup.selection.name):''"
                                            selectLabel
                                            label="name"
                                            track-by="code"
                                            class="mb-2"
                                            deselectLabel
                                            :allow-empty="false"
                                            :selectedLabel="$t('selected')"
                                            :options="optionsForFinOffice()"
                                          >
                                            <div slot="noOptions">{{$t('no_data_text')}}</div>
                                          </multiselect>
                                    <vs-textarea
                                        class="mt-6"
                                        name="comment"
                                        v-model="fin_office_popup.comment"  />

                                    <div>
                                        <input   name="financial_debt" type="checkbox" v-if="checkboxDisplay" class="mt-2 mb-8 checkbox_style" v-model="fin_office_popup.has_financial_debt">
                                        <label class="ml-2" v-if="checkboxDisplay" for="financial_debt">{{ $t('financial_debt') }}</label>
                                    </div>

                                    <vs-button
                                        @click="changeStatus(item, fin_office_popup)"
                                        color="primary"
                                        type="filled">
                                        {{$t('save')}}
                                    </vs-button>
                                </vs-popup>
                            </div>

                        </div>
                    </vx-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import online_registration from "@/store/modules/online_registration";
import Multiselect from 'vue-multiselect'
export default {
    data() {
        return {
            statuses:['DEFAULT', 'CLOSED', 'OPEN'],
            fin_office_popup : {
                status: false,
                selection: null,
                comment: null,
                has_financial_debt: null
            }

        }
    },
    comments:{
        Multiselect
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed:{
        ...mapGetters({
            GET_STATUS_RULES:'online_registration/GET_STATUS_RULES',
            GET_SCHEDULE: "system_settings/GET_SCHEDULE",
        }),
        showID() {
            return this.GET_SCHEDULE && this.GET_SCHEDULE.use_schedule
        },
        user() {
            return this.$store.state.user.user
        },
        checkboxDisplay(){
            if (this.fin_office_popup.selection){
                if (this.fin_office_popup.selection.code === 'CLOSED'){
                    return true
                } else {
                    return false
                }
            }

        }
    },
    methods:{
        ...mapActions({
            changeOnlineRegistrationStatus: "online_registration/changeOnlineRegistrationStatus"
        }),
        statusColor(item) {
            // Меняем цвет статуса
            switch (item.profile.status.name) {
                default:
                    return "primary";
                    // Другие варианты return "#24c1a0"; return "danger"; return "success"; return "dark";
                    break;
            }
        },
        setupPopup(item){
            this.fin_office_popup.selection =  item.online_registration_access
            this.fin_office_popup.comment =  item.comment
            let obj = {}
            obj.code = item.online_registration_access
            obj.name = this.$t(item.online_registration_access)

            this.fin_office_popup.selection = obj
            this.fin_office_popup.status = true
            this.fin_office_popup.has_financial_debt = item.has_financial_debt
        },
        optionsForFinOffice(){
            let statuses = this.statuses.slice()
            let result = []
            for (const status of statuses){
                let obj = {}
                obj.code = status
                obj.name = this.$t(status)
                result.push(obj)
            }
            return result
        },
        clearPopupData(){
            this.fin_office_popup.status = false
            this.fin_office_popup.selection = null
            this.fin_office_popup.comment = null
            this.fin_office_popup.has_financial_debt = null
        },
        changeStatus(item, popupData){

            let payload = {}
            payload.uid = item.uid
            payload.status = popupData.selection.code
            payload.comment = popupData.comment
            if (popupData.selection.code === 'CLOSED'){
                payload.has_financial_debt = popupData.has_financial_debt
            } else{
                payload.has_financial_debt = false
            }

            this.changeOnlineRegistrationStatus(payload)
            this.clearPopupData()
        },
        go_online_registration(item){
            if(this.user.role.is_office){
                let queries = { student:item.profile.uid, student_id:item.profile.student_id, ...this.$route.query };
                this.$router.push({ name:'online-registration-for-courses-adviser', query: queries });
            }
            if(this.user.role.is_supervisor){
                if(!this.GET_STATUS_RULES.start_review_of_studycard_popup.display_exceptions.includes(item.status.code)){
                    this.$emit('start_review_of_studycard', item)
                    return
                }
                let queries = { student:item.profile.uid, student_id:item.profile.student_id, ...this.$route.query };
                this.$router.push({ name:'online-registration-for-courses-adviser', query: queries });
            }
        },
    }
}
</script>

<style lang="scss">

.checkbox_style{
    transform: scale(1.5);
}

//.vs-popup--content{
//    min-height: 15em;
//}
.lang_chip{
    .text-chip{
        text-transform: capitalize;
    }
}
.emc_card{
    display: block;
    color: #2c2c2c;
}
@media only screen and (max-width: 900px) {
    .emc_card{
        .author_label{
            width: 100%;
            font-weight: 600;
        }
        .author_block{
            flex-wrap: wrap;
        }
        .items-start{
            display: block!important;
            .con-vs-chip{
                .text-chip{
                    font-size: 10px;
                }
            }
            .todo-title{
                margin-bottom: 10px!important;
            }
            .items-center{
                margin-bottom: 6px;
            }
        }
    }
}
</style>
